import { Layout, Skeleton } from "../../components/ui";
import { useDeleteParent, useGetParentById } from "../../query/parentQuery";
import { useNavigate, useParams } from "react-router-dom";
import swal from "../../utils/swal";
import ParentProfile from "./ParentProfile";

function ParentDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, data: parent } = useGetParentById(id);
  const { mutate: deleteParent } = useDeleteParent();

  const handleDelete = async () => {
    const realChildren = (parent?.childrens || []).filter(
      (child) => child && (child.firstName || child.lastName || child.rollNumber)
    );
    if (realChildren.length > 0) {
      swal(
        "Cannot delete",
        "This parent still has children assigned. Reassign or remove the children first.",
        "warning"
      );
      return;
    }

    swal({
      title: "Are you sure?",
      text: "Do you want to delete this Parent?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
      dangerMode: true,
    }).then(async function (isConfirm) {
      if (isConfirm) {
        try {
             deleteParent(id, {
        onSuccess: () => {
          swal("Success", "Parent deleted successfully", "success");
              navigate("/parents");
        },
        onError: (error) => {
          swal("Cannot delete", error?.message || "Failed to delete parent", "error");
        },
      });
        } catch (err) {
          console.log(err);
        }
      }
    });
    };

  return (
    <Layout className="configuration">
      <div
        className="boxDetails"
        style={{ background: "transparent", padding: 0, boxShadow: "none" }}
      >
        {isLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              marginBottom: "20px",
              marginTop: "20px",
            }}
          >
            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}

        {!isLoading && parent && (
          <ParentProfile parent={parent} onDelete={handleDelete} />
        )}
      </div>
    </Layout>
  );  
}

export default ParentDetails;
